module.exports = __webpack_public_path__ + "img/UTKODA-3.57f102da.jpg";